<ng-container *ngIf="isSmallIcon">
  <document-upload-ocr [id]="documentUploadOcrId" isSmallIcon="true" (upload)="onUploadFile($event)"></document-upload-ocr>
</ng-container>

<ng-container *ngIf="!isSmallIcon">
  <div class="replace-invoice">
    <div class="replace-invoice-header">
      <div class="replace-invoice-header-icon">
        <div class="replace-invoice-header-icon-container">
          <img src="assets/icons/icon_invoice_upload.svg" class="replace-invoice-header-icon-img" />
          <border-spinner *ngIf="isLoading"></border-spinner>
        </div>
      </div>

      <div class="replace-invoice-header-title">{{ "DOCUMENT_TYPE.FREIGHT_USER_INVOICE" | translate }}</div>

      <div class="replace-invoice-header-label">{{ "LABELS.REQUIRED" | translate }}</div>

      <div class="replace-invoice-header-hint">{{ "ES_ADD_INVOICE_STEP_1" | translate }}</div>
    </div>

    <div class="replace-invoice-footer">
      <document-upload-ocr [id]="documentUploadOcrId" hint="OCR_FORMATS_HINT" (upload)="onUploadFile($event)"></document-upload-ocr>

      <div class="replace-invoice-footer-is-loading" *ngIf="isLoading"></div>
    </div>
  </div>
</ng-container>

<custom-modal [header]="'UPLOAD_INVOICE'" [open]="isShowOCRModal" (openChange)="hideOCRModal()">
  <div class="replace-invoice-modal">
    <div class="replace-invoice-modal-hint">{{ "SELECT_THE_METHOD_OCR" | translate }}</div>

    <div class="replace-invoice-modal-options">
      <div class="mr-2" *ngFor="let option of uploadOptions">
        <app-radio-button
          name="type"
          [id]="option.id"
          [value]="option.value"
          [control]="uploadFc"
          [label]="option.label"
        ></app-radio-button>
      </div>
    </div>
  </div>

  <button footer-action type="button" class="btn btn-primary replace-invoice-continue" (click)="onProcessFile()">
    <span class="d-flex align-items-center">
      {{ "BUTTON.CONTINUE" | translate }}

      <img class="ml-2" src="assets/icons/icon_arrow_right_sm_white.svg" />
    </span>
  </button>
</custom-modal>
